import { computed, ComputedRef, Ref } from 'vue'

/**
 * Bridges a Date (or null) to a DD/MM/YYYY string representation.
 *
 * @param dateRef - Ref holding a Date or null
 */
export function useFormattedDate(
  dateRef: Ref<Date | null>
): ComputedRef<string> {
  return computed<string>({
    get() {
      if (!dateRef.value) return ''

      const d = dateRef.value
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear()

      return `${day}/${month}/${year}`
    },
    set(value: string) {
      if (!value) {
        dateRef.value = null
        return
      }

      const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value)
      if (!match) return

      const [, day, month, year] = match.map(Number)

      dateRef.value = new Date(year, month - 1, day)
    }
  })
}
